import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { purchasesAPI } from '../../services/api';
import toast from 'react-hot-toast';

const fmt = (n) => Number(n||0).toLocaleString('en-IN',{style:'currency',currency:'INR',maximumFractionDigits:0});

export default function GRNList() {
  const [grns, setGrns] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try { const r = await purchasesAPI.listGRN({ limit: 100 }); setGrns(r.data.grns); }
    catch { toast.error('Failed to load'); }
    finally { setLoading(false); }
  }, []);

  useEffect(() => { load(); }, [load]);

  const statusMap = { draft: 'badge-gray', verified: 'badge-blue', approved: 'badge-green', cancelled: 'badge-red' };

  return (
    <div>
      <div className="page-header">
        <div><h1>Goods Received Notes</h1><p className="subtitle">{grns.length} GRNs</p></div>
        <Link to="/purchases/grn/new" className="btn btn-primary">+ New GRN</Link>
      </div>
      <div className="card"><div className="table-container">
        {loading ? <div className="loading-container"><div className="spinner" /></div> : (
          <table>
            <thead><tr><th>GRN #</th><th>Supplier</th><th>Warehouse</th><th>PO Ref</th><th>Date</th><th>Supplier Inv</th><th style={{textAlign:'right'}}>Amount</th><th>Status</th></tr></thead>
            <tbody>
              {grns.map(g => (
                <tr key={g.id}>
                  <td className="td-mono font-semibold">{g.grn_number}</td>
                  <td>{g.supplier_name}</td><td className="text-secondary">{g.warehouse_name}</td>
                  <td className="td-mono">{g.po_number || '-'}</td>
                  <td className="text-secondary">{new Date(g.grn_date).toLocaleDateString('en-IN')}</td>
                  <td className="td-mono">{g.supplier_invoice_no || '-'}</td>
                  <td className="td-amount font-bold">{fmt(g.total_amount)}</td>
                  <td><span className={`badge ${statusMap[g.status]}`}>{g.status}</span></td>
                </tr>
              ))}
              {grns.length === 0 && <tr><td colSpan={8} className="text-center text-secondary" style={{padding:40}}>No GRNs yet</td></tr>}
            </tbody>
          </table>
        )}
      </div></div>
    </div>
  );
}
